import React from "react";
import styled from "styled-components";
import { Box, LazyImage, SpanStyled, TextStyled } from "../../styled/Elements";

const NewCustomRadio = ({
  label,
  value,
  checked,
  onChange,
  name,
  subLabel,
  avatar,
  register,
  validationRules,
  disabled,
  padding,
  ...rest
}) => {
  return (
    <RadioWrapper padding={padding} {...rest} checked={checked}>
      <Box className="d-flex align-items-center gap-2">
        {avatar && (
          <Box className="userPlaceholder">
            <LazyImage src={avatar} />
          </Box>
        )}
        <Box>
          <SpanStyled
            size="16px"
            weight="bold"
            color="var(--text)"
            checked={checked}
          >
            {label}
          </SpanStyled>
          <TextStyled
            size="14px"
            weight="300"
            color="var(--text2)"
            checked={checked}
          >
            {subLabel}
          </TextStyled>
        </Box>
      </Box>
      <Box>
        <input
          className="radio-input"
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          {...(register && register(name, validationRules))}
        />
      </Box>
    </RadioWrapper>
  );
};

export default NewCustomRadio;

const RadioWrapper = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${({ padding }) => (padding ? padding : "11px 15px")};
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: var(--white);

  .radio-input {
    appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid var(--border);
    border-radius: 50%;
    background-color: var(--white);
    position: relative;
    transition: all 0.2s ease;
    cursor: pointer;
  }

  .radio-input:checked {
    border: 2px solid var(--themeColor);
  }

  .radio-input:checked::after {
    content: "";
    width: 10px;
    height: 10px;
    background-color: var(--themeColor);
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  /* .radio-text {
    font-weight: ${(props) => (props.checked ? "bold" : "normal")};
    color: ${(props) => (props.checked ? "var(--themeColor2)" : "var(--text)")};
  } */
`;
